module.exports = __webpack_public_path__ + "img/hotel-26.d2b34359.jpeg";